import { render, staticRenderFns } from "./PIA.vue?vue&type=template&id=eaa4af64&scoped=true"
import script from "./PIA.vue?vue&type=script&lang=js"
export * from "./PIA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaa4af64",
  null
  
)

export default component.exports